module.exports = __webpack_public_path__ + "img/hrm-jordan-lg.11f5ad5.png";